import { Command } from "prosemirror-state";
import { keymap } from "prosemirror-keymap";

import { BaseExtension } from "@/wc/text-editor/lib/core/base-extension";
import type { MenuFunction } from "@/wc/text-editor/lib/core/config";
import { MenuItemState } from "@/wc/text-editor/lib/core/menu";

import { dispatchHostEvent } from "@/wc/text-editor/lib/core/plugins/host-events.js";

export const sendSaveEvent: Command = (state) => {
    dispatchHostEvent(state, "save");
    return true;
};

export const sendLoadEvent: Command = (state) => {
    dispatchHostEvent(state, "load");
    return true;
};

export const sendMaximizeEvent: Command = (state) => {
    dispatchHostEvent(state, "maximize");
    return true;
};

const saveKeymap = () =>
    keymap({
        "Ctrl-s": sendSaveEvent,
        "Ctrl-o": sendLoadEvent,
        "Ctrl-m": sendMaximizeEvent,
    });

export class LocalFilesExtension extends BaseExtension {
    menu?: (currentMenu: MenuFunction) => MenuFunction = (currentMenu) => {
        return (view) => {
            const menu: Array<MenuItemState> = [
                {
                    type: "toggle",
                    run: () => sendLoadEvent(view.state),
                    label: "Load",
                    icon: { name: "folder" },
                },
                {
                    type: "toggle",
                    run: () => sendSaveEvent(view.state),
                    label: "Save",
                    icon: { name: "save" },
                },
                ...currentMenu(view),
                {
                    type: "toggle",
                    run: () => sendMaximizeEvent(view.state),
                    icon: { name: "arrows-fullscreen" },
                },
            ];
            return menu;
        };
    };
    plugins = () => [saveKeymap()];
}
